// @ts-nocheck
/* eslint-disable */

"use client";

import {
  Button,
  Column,
  Flex,
  FormField,
  Heading,
  Icon,
  RichText,
  Row,
  variables,
} from "daskapital-ds";
import React, { useEffect, useRef, useState } from "react";
import {
  StyledBubble,
  calculateLoanAmountInstalment,
  calculateLoanAmountInstalmentWithTaxes,
  calculateLoanAmountReceived,
  calculateLoanTotalPayment,
  calculateMaintenanceFee,
  calculateTotalMaintenanceFee,
  formatAsCurrency,
  formatMonthsToHuman,
  formsAttrs,
  getCommissionPercentage,
  getInstalmentFrequencyValue,
  getStampTax,
  validateStringData,
} from "./simulator.utils";

import Link from "next/link";
import { NumericFormat } from "react-number-format";
import { useGlobalContext } from "@/lib/globalContext";
import Tooltip from "../Tooltip/Tooltip";
import Newsletter from "../Newsletter";

export default function FundProjects({
  getStarted,
  knowMore,
  title,
  description,
  backgroundColor,
  textColor,
  termsDescription,
  primaryButtonText,
  secondaryButtonText,
  showNotifyMe,
}: formsAttrs) {
  const state = useGlobalContext();
  const shouldShowNotifyMe = showNotifyMe ?? false;
  const maturityDays = [6, 9, 12, 18, 24, 36, 48, 60, 72, 84, 96, 108, 120];

  const defaultInstallments = [
    {
      value: "MONTHLY",
      label: state?.dict?.custom?.monthly,
      include: [6, 9, 12, 18, 24, 36, 48, 60, 72, 84, 96, 108, 120],
      divider: 1,
    },
    {
      value: "BIMONTHLY",
      label: state?.dict?.custom?.bimonthly,
      include: [6, 9, 12, 18, 24, 36, 48, 60, 72, 84, 96, 108, 120],
      divider: 2,
    },
    {
      value: "QUARTERLY",
      label: state?.dict?.custom?.quarterly,
      include: [6, 9, 12, 18, 24, 36, 48, 60, 72, 84, 96, 108, 120],
      divider: 3,
    },
    {
      value: "SEMIYEARLY",
      label: state?.dict?.custom?.semiyearly,
      include: [6, 9, 12, 18, 24, 36, 48, 60, 72, 84, 96, 108, 120],
      divider: 6,
    },
    {
      value: "ANNUALLY",
      label: state?.dict?.custom?.annually,
      include: [12, 18, 24, 36, 48, 60, 72, 84, 96, 108, 120],
      divider: 12,
    },
  ];

  const [message, setMessage] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [fields, setFields] = useState<Record<string, string | number>>({
    maturityDays: maturityDays[0],
    interestRate: 4,
    installment: "MONTHLY",
  });
  const [total, setTotal] = useState<number>(0);
  const [upfront, setUpfront] = useState<number>(0);
  const [amountInstalment, setAmountInstalment] = useState<number>(0);
  const [amountInstalmentWithTaxes, setAmountInstalmentWithTaxes] =
    useState<number>(0);
  const [amountReceived, setAmountReceived] = useState<number>(0);
  const [totalPayment, setTotalPayment] = useState<number>(0);
  const [vat, setVat] = useState<number>(0);
  const [maintenanceFee, setmaintenanceFee] = useState<number>(0);
  const [stampTax, setStampTax] = useState<number>(0);
  const [commissionPercentage, setCommissionPercentage] = useState<number>(0);
  const [totalFees, setTotalFees] = useState<number>(0);
  const [installmentOptions, setInstallmentOptions] =
    useState(defaultInstallments);

  useEffect(() => {
    const newInstallments = defaultInstallments;
    const filteredInstallments = newInstallments.filter(
      (e) => e.include.indexOf(fields.maturityDays) < 0,
    );
    filteredInstallments.forEach((f) =>
      newInstallments.splice(
        newInstallments.findIndex((e) => e.value === f.value),
        1,
      ),
    );

    //change installment value state if not in array
    if (newInstallments.findIndex((e) => e.value === fields.installment) < 0) {
      setFields({ ...fields, installment: "MONTHLY" });
    }
    setInstallmentOptions(newInstallments);
  }, [fields.maturityDays]);

  const formatter = new Intl.NumberFormat(`fr-FR`, {
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const setValue = (key, value) => {
    setFields({ ...fields, [key]: value });
    // calcTotal();
  };

  const calcTotal = () => {
    if (
      fields.amount > 0 &&
      fields.interestRate > 0 &&
      fields.maturityDays > 0 &&
      fields.installment !== ""
    ) {
      const amount_requested = fields.amount;
      const instalment_freq = fields.installment;
      const term_months = fields.maturityDays;
      const max_apr = fields.interestRate;
      const country_code = state?.user?.country_code;

      const params = {
        instalment_freq,
        amount_requested,
        term_months,
        max_apr,
      };
      const amountInstalmentCalc = calculateLoanAmountInstalment(params);
      const amountInstalmentCalcWithTaxes =
        calculateLoanAmountInstalmentWithTaxes({
          amount_installment: amountInstalmentCalc,
          amount_requested,
          instalment_freq,
        });
      setVat(0);
      setCommissionPercentage(getCommissionPercentage(amount_requested));
      setmaintenanceFee(
        calculateMaintenanceFee(amount_requested, instalment_freq),
      );
      setStampTax(getStampTax(amount_requested, term_months));
      setAmountInstalment(amountInstalmentCalc);
      setAmountInstalmentWithTaxes(amountInstalmentCalcWithTaxes);
      setAmountReceived(
        calculateLoanAmountReceived(amount_requested, term_months),
      );
      setTotalPayment(
        calculateLoanTotalPayment({
          ...params,
        }),
      );
      const inst_freq = getInstalmentFrequencyValue(instalment_freq);

      setTotalFees(
        getCommissionPercentage(amount_requested) +
          calculateTotalMaintenanceFee(
            amount_requested,
            inst_freq,
            term_months,
            max_apr,
          ),
      );
    } else {
      setAmountInstalment(0);
      setAmountReceived(0);
      setTotalPayment(0);
    }
  };

  useEffect(() => {
    calcTotal();
  }, [fields]);

  useEffect(() => {
    document.querySelectorAll('input[type="number"]').forEach((item) => {
      item.dispatchEvent(new Event("change"));
    });

    calcTotal();
  }, []);

  return (
    <>
      <div
        className="block-group radius-md"
        style={{
          padding: "16px",
          overflow: "hidden",
          ...(backgroundColor ? { backgroundColor } : {}),
          ...(textColor ? { color: textColor } : {}),
        }}
      >
        <Row fluid={true} className="m-0">
          <Column lg={8}>
            <div className="mb-8 mb-md-0 pe-md-8">
              <Heading size={"h3"} tag={"h4"}>
                {title || state?.dict?.custom?.fundProject}
              </Heading>
              <Heading
                size={"texts"}
                tag={"span"}
                className="font-alternative mt-3"
              >
                {description || state?.dict?.custom?.fundProjectTxt}
              </Heading>

              {shouldShowNotifyMe && (
                <div className="d-flex bg-gray10 radius-sm p-4 mt-5">
                  <Newsletter
                    label={state?.dict?.custom?.notifyAvailableTitle}
                    placeholder={
                      state?.dict?.custom?.notifyAvailablePlaceholder
                    }
                    buttonText={state?.dict?.custom?.notifyAvailableButton}
                  />
                </div>
              )}
              <div className="mt-7">
                <Heading
                  size={"texts"}
                  tag={"span"}
                  className="font-alternative"
                >
                  {state?.dict?.custom?.amountTitleFund}
                </Heading>
                <div className="mt-2">
                  <FormField id="amount" className="mb-0">
                    <NumericFormat
                      thousandSeparator=" "
                      decimalSeparator=","
                      suffix={"€"}
                      decimalScale={2}
                      allowNegative={false}
                      name="amount"
                      placeholder={state?.dict?.custom?.amount}
                      className="font-alternative w-100"
                      onChange={(e) => {
                        setValue(
                          "amount",
                          parseFloat(
                            e.target.value
                              .replaceAll(" ", "")
                              .replaceAll(",", "."),
                          ),
                        );
                      }}
                    />
                  </FormField>
                </div>
              </div>
              <div className="mt-5">
                <Heading
                  size={"texts"}
                  tag={"span"}
                  className="font-alternative"
                >
                  {state?.dict?.custom?.maturityDaysProjects}
                </Heading>
                <div
                  className="d-flex align-items-center mt-2"
                  style={{ gap: "1rem" }}
                >
                  <div className="flex-grow-1 pt-1">
                    <FormField
                      id="maturityDays"
                      className="mb-0 align-items-center"
                    >
                      <input
                        type={"range"}
                        name="maturityDays"
                        className="w-100"
                        rangevalues={maturityDays}
                        max={maturityDays.length - 1}
                        defaultValue={0}
                        onChange={(e) => {
                          e.preventDefault();
                          setValue(
                            "maturityDays",
                            maturityDays[e.target.value],
                          );
                        }}
                      />
                    </FormField>
                  </div>
                  <div className="flex-shrink-1">
                    <StyledBubble type="text" className="texts">
                      {fields.maturityDays}
                    </StyledBubble>
                  </div>
                </div>
              </div>

              <div className="mt-5">
                <Heading
                  size={"texts"}
                  tag={"span"}
                  className="font-alternative"
                >
                  {state?.dict?.custom?.installment}
                </Heading>
                <div
                  className="d-flex align-items-center mt-2"
                  style={{ gap: "1rem" }}
                >
                  <div className="flex-grow-1">
                    <FormField id="installment" className="mb-0">
                      <select
                        name="installment"
                        className="w-100"
                        onChange={(e) => {
                          setValue("installment", e.target.value);
                        }}
                      >
                        {installmentOptions.map((install, index) => {
                          return (
                            <option
                              key={`installment-${index}`}
                              value={install.value}
                            >
                              {install.label}
                            </option>
                          );
                        })}
                      </select>
                    </FormField>
                  </div>
                </div>
              </div>

              <div className="mt-5">
                <Tooltip
                  content={
                    state?.dict?.custom?.interestRateInvestFundProjectsTooltip
                  }
                  displayIcon={true}
                  place="top"
                >
                  <Heading
                    size={"texts"}
                    tag={"span"}
                    className="font-alternative"
                  >
                    {state?.dict?.custom?.interestRateMax}
                  </Heading>
                </Tooltip>
                <div
                  className="d-flex align-items-center mt-2"
                  style={{ gap: "1rem" }}
                >
                  <div className="flex-grow-1 pt-1">
                    <FormField id="interestRate" className="mb-0">
                      <input
                        type={"range"}
                        name="interestRate"
                        className="w-100"
                        min={4}
                        max={20}
                        step={0.1}
                        defaultValue={4}
                        onChange={(e) => {
                          setValue("interestRate", e.target.value);
                        }}
                      />
                    </FormField>
                  </div>
                  <div className="flex-shrink-1">
                    <StyledBubble type="text" className="texts">
                      {fields.interestRate}%
                    </StyledBubble>
                  </div>
                </div>
              </div>

              <div className="d-flex bg-gray70 radius-sm p-4 mt-9">
                <Icon
                  icon="icon-info"
                  className="color-secondary50 mt-1 me-2"
                />
                <span className="d-block">
                  <p className="color-white">
                    {termsDescription || state?.dict?.custom?.termsFundProjects}
                  </p>
                </span>
              </div>
            </div>
          </Column>
          <Column lg={4} className="bg-gray70 color-white radius-sm">
            <div
              className="d-flex justify-content-between p-4 h-100 simulator-totals"
              style={{ flexFlow: "column" }}
            >
              <div>
                <div className="d-flex flex-column justify-content-between align-items-end mb-5 gap-8">
                  <p className="h5" style={{ fontSize: "16px" }}>
                    <b>
                      {state?.dict?.custom?.payMaxInstallmentOf?.replaceAll(
                        "{{installment}}",
                        validateStringData(
                          installmentOptions
                            .find((e) => e.value === fields.installment)
                            ?.label?.toLowerCase(),
                        ),
                      )}
                    </b>
                  </p>

                  <Heading
                    style={{ fontSize: "38px" }}
                    tag={"span"}
                    className="color-secondary50 mx-4"
                  >
                    {formatAsCurrency(amountInstalmentWithTaxes)}
                  </Heading>
                </div>

                <div className="w-100">
                  <div className="m-b-24">
                    <div className="m-b-12">
                      <p
                        style={{
                          fontSize: "16px",
                          lineHeight: "170%",
                          marginBottom: "4px",
                        }}
                        className="d-flex flex-row justify-content-between"
                      >
                        <b className="color-gray40">
                          {" "}
                          {state?.dict?.custom?.installmentLabel?.replaceAll(
                            "{{installment}}",
                            validateStringData(
                              installmentOptions
                                .find((e) => e.value === fields.installment)
                                ?.label?.toLowerCase(),
                            ),
                          )}{" "}
                        </b>
                        {formatAsCurrency(amountInstalment)}
                      </p>

                      <p
                        style={{
                          fontSize: "16px",
                          lineHeight: "170%",
                        }}
                        className="d-flex flex-row justify-content-between"
                      >
                        <b className="color-gray40">
                          {state?.dict?.custom?.maintenanceFee}
                        </b>
                        {formatAsCurrency(maintenanceFee)}
                      </p>
                    </div>
                  </div>
                </div>

                {/* YOU WILL RECEIVE */}
                <div
                  className="bg-gray90 p-4 radius-sm"
                  style={{ borderRadius: "4px", marginTop: "24px" }}
                >
                  <div className="d-flex flex-row justify-content-between align-items-center mb-3">
                    <p className="h4">
                      <b>{state?.dict?.custom?.youWillReceive}</b>
                    </p>

                    <Heading
                      size={"h4"}
                      tag={"span"}
                      className="color-secondary50"
                    >
                      {formatAsCurrency(amountReceived)}
                    </Heading>
                  </div>

                  <div className="m-b-12">
                    <p
                      style={{ fontSize: "16px", lineHeight: "170%" }}
                      className="d-flex flex-row justify-content-between"
                    >
                      <b className="color-gray40">
                        {state?.dict?.custom?.processingFee}
                      </b>
                      {formatAsCurrency(commissionPercentage)}
                    </p>
                  </div>
                </div>

                {/* TOTAL COST OF THE LOAN */}
                <div
                  className="bg-gray90 p-4 radius-sm"
                  style={{ borderRadius: "4px", marginTop: "24px" }}
                >
                  <div className="d-flex flex-row justify-content-between align-items-center mb-3">
                    <p className="h4">
                      <b>{state?.dict?.custom?.totalCostOfLoan}</b>
                    </p>

                    <Heading
                      size={"h4"}
                      tag={"span"}
                      className="color-secondary50"
                    >
                      {formatAsCurrency(totalPayment)}
                    </Heading>
                  </div>

                  <div className="m-b-12">
                    <p
                      style={{
                        fontSize: "16px",
                        lineHeight: "170%",
                        marginBottom: "4px",
                      }}
                      className="d-flex flex-row justify-content-between"
                    >
                      <b className="color-gray40">
                        {state?.dict?.custom?.capital}
                      </b>
                      {formatAsCurrency(fields.amount)}
                    </p>

                    <p
                      style={{
                        fontSize: "16px",
                        lineHeight: "170%",
                        marginBottom: "4px",
                      }}
                      className="d-flex flex-row justify-content-between"
                    >
                      <b className="color-gray40">
                        {state?.dict?.custom?.interests}
                      </b>
                      {formatAsCurrency(
                        totalPayment -
                          Number(fields.amount) -
                          totalFees -
                          totalFees * vat,
                      )}
                    </p>

                    <p
                      style={{
                        fontSize: "16px",
                        lineHeight: "170%",
                        marginBottom: "4px",
                      }}
                      className="d-flex flex-row justify-content-between"
                    >
                      <b className="color-gray40">
                        {state?.dict?.custom?.fees}
                      </b>
                      {formatAsCurrency(totalFees)}
                    </p>
                  </div>
                </div>
              </div>

              <div className="text-center mt-5">
                <Link
                  href={
                    getStarted?.url
                      ? getStarted?.url
                      : "https://platform.daskapital.eu/register"
                  }
                  target="_blank"
                  rel="noreferrer noopener"
                  className="d-block"
                >
                  <Button
                    variant="secondary"
                    className="justify-content-center w-100"
                    style={{ padding: "22px 26px" }}
                  >
                    {primaryButtonText || state.dict?.custom?.getStarted}
                  </Button>
                </Link>
                <Link
                  href={knowMore?.url ? knowMore?.url : "/contacts"}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="d-inline-block"
                >
                  <Button
                    variant="link"
                    className="color-white"
                    style={{ padding: "22px 26px" }}
                  >
                    {secondaryButtonText || state.dict?.common?.knowMore}
                  </Button>
                </Link>
              </div>

              {message && (
                <RichText tag="p" className="color-white mt-5">
                  {message}
                </RichText>
              )}
            </div>
          </Column>
        </Row>
      </div>
    </>
  );
}
